import React from "react";
import { Layout, Row, Col, List, message, Select, Empty, Icon } from "antd";
import MiCompAPI from "../util/api";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";

import img1 from "../assets/img/At the office-pana 1.png";

import moment from "moment";
const { Content } = Layout;
const { Option } = Select;
class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: [],
      agency: [],
      broker: [],
      options: {},
      underwriter: [],
      other: [],
      invitationManager: [],
      salesFinance: [],
      reportsscheduler: [],
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      months: [],
      years: [],
      visible: false,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  componentDidMount = () => {
    this.getClientMasters();
    setTimeout(() => {
      this.GetDashboardDate(this.state.month, this.state.year);
    }, 100);
  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            years: data.years,
            months: data.months,
          });
        }
      },
      ["YR", "MTH"]
    );
  }
  GetDashboardDate = (mnth, yr) => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;

    var url = "";
    if (role === "broker") {
      url = "GetBrokerDashboard";
    } else if (role === "agency") {
      url = "GetAgencyDashboard";
    } else if (role === "bsu admin") {
      url = "GetAdminDashboard";
    } else if (role === "underwriter") {
      url = "UnderwriterDashboard";
    } else if (role === "invitation manager") {
      url = "InvitationManagerDashboard";
    } else if (role === "sales/finance team") {
      url = "SalesFinance";
    } else if (role === "report ccheduler") {
      url = "ReportsSchedulerDashboard";
    } else {
      url = "";
    }
    this.api.invoke(url + "/" + mnth + "/" + yr, "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          if (role === "broker") {
            this.setState({
              broker: data.data,
            });
          } else if (role === "agency") {
            this.setState({ agency: data.data });
          } else if (role === "bsu admin") {
            this.setState({
              admin: data.data,
            });
          } else if (role === "underwriter") {
            this.setState({
              underwriter: data.data,
            });
          } else if (role === "invitation manager") {
            this.setState({
              invitationManager: data.data,
            });
          } else if (role === "sales/finance team") {
            this.setState({
              salesFinance: data.data,
            });
          } else if (role === "report ccheduler") {
            this.setState({
              reportsscheduler: data.data,
            });
          } else {
            this.setState({
              other: data.data,
            });
          }
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };
  onChange = (type, e) => {
    if (type === "month") {
      this.setState({ month: e });
    }
    if (type === "year") {
      this.setState({ year: e });
    }
    if (this.state.month && this.state.year) {
      setTimeout(() => {
        this.GetDashboardDate(this.state.month, this.state.year);
      }, 100);
    }
  };
  render() {
    const {
      admin,
      agency,
      broker,
      underwriter,
      invitationManager,
      salesFinance,
    } = this.state;
    const { decodedToken } = this.props.userPermandMasters;

    var role = decodedToken.UserRoleName;
    var userdId = decodedToken.UserId;
    let dashboard = <></>;

    let searchfilter = (
      <Col md={24} style={{ margin: "20px 0px" }}>
        <div style={{ display: "flex", float: "right", marginRight: "15px" }}>
          <h3>
            <b>Year :&emsp;</b>
          </h3>
          {this.state.year ? (
            <Select
              suffixIcon={
                <Icon
                  style={{ transform: "rotate(90deg)" }}
                  type="double-right"
                />
              }
              className="mi_input_profile"
              style={{ width: "150px" }}
              onChange={this.onChange.bind(this, "year")}
              placeholder="Please Select"
              showSearch={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              defaultValue={this.state.year ? this.state.year : undefined}
            >
              {this.state.years
                ? this.state.years.map((tag) => (
                    <Option value={tag.id} key={tag.id}>
                      {tag.name}
                    </Option>
                  ))
                : ""}
            </Select>
          ) : (
            ""
          )}
        </div>
        <div style={{ display: "flex", float: "right", marginRight: "15px" }}>
          <h3>
            <b>Month :&emsp;</b>
          </h3>
          <Select
            suffixIcon={
              <Icon
                style={{ transform: "rotate(90deg)" }}
                type="double-right"
              />
            }
            className="mi_input_profile"
            style={{ width: "150px" }}
            onChange={this.onChange.bind(this, "month")}
            placeholder="Please Select"
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            defaultValue={this.state.month ? this.state.month : undefined}
          >
            {this.state.months
              ? this.state.months.map((tag) => (
                  <Option value={tag.id} key={tag.id}>
                    {tag.name}
                  </Option>
                ))
              : ""}
          </Select>
        </div>
      </Col>
    );
    if (role === "broker") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={8} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{broker.active_plan}</p>
                <p className="mi_card_tit">Active plans</p>
              </div>
            </Col>
            <Col lg={8} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{broker.total_active_members}</p>
                <p className="mi_card_tit">Total active Members onboarded</p>
              </div>
            </Col>
            <Col lg={8} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{broker.new_members_current_mnth}</p>
                <p className="mi_card_tit">New members (current month)</p>
              </div>
            </Col>
          </Row>
          <Row span={24}>{searchfilter}</Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Commission Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {broker.plan_vs_com && broker.plan_vs_com.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Commission",
                                    formatter: function (w) {
                                      return (
                                        "$" +
                                        w.globals.seriesTotals.reduce(
                                          (a, b) => {
                                            return a + b;
                                          },
                                          0
                                        )
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: broker.plan_vs_com
                            ? broker.plan_vs_com.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          broker.plan_vs_com
                            ? broker.plan_vs_com.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Member Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {broker.plan_vs_meb && broker.plan_vs_meb.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Members",
                                    formatter: function (w) {
                                      return w.globals.seriesTotals.reduce(
                                        (a, b) => {
                                          return a + b;
                                        },
                                        0
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: broker.plan_vs_meb
                            ? broker.plan_vs_meb.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          broker.plan_vs_meb
                            ? broker.plan_vs_meb.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Renewals</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={broker.pendingRenevals}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">{item.plan_name}</p>
                          <p className="mi_dash_cont1">
                            {item.start_date
                              ? moment(item.start_date).format("MM/DD/YYYY")
                              : "none"}
                          </p>
                          <p className="mi_dash_cont1">
                            {item.end_date
                              ? moment(item.end_date).format("MM/DD/YYYY")
                              : "none"}
                          </p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {broker.pendingRenevals &&
                    broker.pendingRenevals.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
            <Col md={12} sm={24}></Col>
          </Row>
        </div>
      );
    } else if (role === "agency") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={8} md={8} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{agency.active_plan}</p>
                <p className="mi_card_tit">Active Plans</p>
              </div>
            </Col>
            <Col lg={8} md={8} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{agency.total_active_members}</p>
                <p className="mi_card_tit">Total Active Members onboarded</p>
              </div>
            </Col>
            <Col lg={8} md={8} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{agency.new_members_current_mnth}</p>
                <p className="mi_card_tit">New members (current month)</p>
              </div>
            </Col>
          </Row>
          <Row span={24}>{searchfilter}</Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Commission Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {agency.plan_vs_com && agency.plan_vs_com.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Commission",
                                    formatter: function (w) {
                                      return (
                                        "$" +
                                        w.globals.seriesTotals.reduce(
                                          (a, b) => {
                                            return a + b;
                                          },
                                          0
                                        )
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: agency.plan_vs_com
                            ? agency.plan_vs_com.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          agency.plan_vs_com
                            ? agency.plan_vs_com.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Member Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {agency.plan_vs_meb && agency.plan_vs_meb.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Members",
                                    formatter: function (w) {
                                      return w.globals.seriesTotals.reduce(
                                        (a, b) => {
                                          return a + b;
                                        },
                                        0
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: agency.plan_vs_meb
                            ? agency.plan_vs_meb.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          agency.plan_vs_meb
                            ? agency.plan_vs_meb.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Approvals</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={agency.pending_broker}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">{item.name}</p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {agency.pending_broker &&
                    agency.pending_broker.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Renevals</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={agency.pendingRenevals}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">{item.plan_name}</p>
                          <p className="mi_dash_cont1">
                            {item.start_date
                              ? moment(item.start_date).format("MM/DD/YYYY")
                              : "none"}
                          </p>
                          <p className="mi_dash_cont1">
                            {item.end_date
                              ? moment(item.end_date).format("MM/DD/YYYY")
                              : "none"}
                          </p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {agency.pendingRenevals &&
                    agency.pendingRenevals.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (role === "bsu admin") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{admin.total_brokers_onboard}</p>
                <p className="mi_card_tit">Total brokers Onboarded</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{admin.total_ageny_onboard}</p>
                <p className="mi_card_tit">Total Agencies Onboarded</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {admin.total_brokers_onboard_current_mnth}
                </p>
                <p className="mi_card_tit">New Brokers (current month)</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {admin.total_ageny_onboard_current_mnth}
                </p>
                <p className="mi_card_tit">New Agencies (current month)</p>
              </div>
            </Col>
          </Row>
          <Row span={24}>{searchfilter}</Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Commission Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {admin.plan_vs_com && admin.plan_vs_com.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Commission",
                                    formatter: function (w) {
                                      return (
                                        "$" +
                                        w.globals.seriesTotals.reduce(
                                          (a, b) => {
                                            return a + b;
                                          },
                                          0
                                        )
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: admin.plan_vs_com
                            ? admin.plan_vs_com.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          admin.plan_vs_com
                            ? admin.plan_vs_com.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Plan Vs Member Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {admin.plan_vs_meb && admin.plan_vs_meb.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Members",
                                    formatter: function (w) {
                                      return w.globals.seriesTotals.reduce(
                                        (a, b) => {
                                          return a + b;
                                        },
                                        0
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: admin.plan_vs_meb
                            ? admin.plan_vs_meb.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          admin.plan_vs_meb
                            ? admin.plan_vs_meb.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Approvals</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Agencies </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={admin.pending_agency}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">
                            <Link
                              to={{
                                pathname: "/agencies/" + item.id,
                                state: { agencyId: item.id, tab: "doc" },
                              }}
                            >
                              {item.name}
                            </Link>
                          </p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {admin.pending_agency &&
                    admin.pending_agency.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Brokers </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={admin.pending_broker}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">
                            <Link
                              to={{
                                pathname: "/brokers/" + item.id,
                                state: { broker_id: item.id, tab: "doc" },
                              }}
                            >
                              {item.name}
                            </Link>
                          </p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {admin.pending_broker &&
                    admin.pending_broker.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Invitations</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Agencies Invitation </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={admin.pending_inv_agency}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">{item.name}</p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {admin.pending_inv_agency &&
                    admin.pending_inv_agency.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Broker Invitation </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={admin.pending_inv_broker}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">{item.name}</p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {admin.pending_inv_broker &&
                    admin.pending_inv_broker.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (role === "underwriter") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {underwriter.total_brokers_onboard}
                </p>
                <p className="mi_card_tit">Total brokers Onboarded</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">{underwriter.total_ageny_onboard}</p>
                <p className="mi_card_tit">Total Agencies Onboarded</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {underwriter.total_brokers_pending_approvals}
                </p>
                <p className="mi_card_tit">Total Brokers Pending Approvals</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {underwriter.total_ageny_pending_approvals}
                </p>
                <p className="mi_card_tit">Total Agency Pending Approvals</p>
              </div>
            </Col>
          </Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Pending Approvals</p>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Agencies </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={underwriter.pending_agency}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">
                            <Link
                              to={{
                                pathname: "/agencies/" + item.id,
                                state: { agencyId: item.id, tab: "doc" },
                              }}
                            >
                              {item.name}
                            </Link>
                          </p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {underwriter.pending_agency &&
                    underwriter.pending_agency.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
                <Row span={24} style={{ marginBottom: "10px" }}>
                  <p className="mi_dash_tit1">Brokers </p>
                  <List
                    pagination={{ pageSize: 5, position: "bottom" }}
                    dataSource={underwriter.pending_broker}
                    renderItem={(item) => (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">
                            <Link
                              to={{
                                pathname: "/brokers/" + item.id,
                                state: { broker_id: item.id, tab: "doc" },
                              }}
                            >
                              {item.name}
                            </Link>
                          </p>
                          <p className="mi_dash_cont">{item.email}</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  >
                    {underwriter.pending_broker &&
                    underwriter.pending_broker.length !== 0 ? (
                      ""
                    ) : (
                      <>
                        <List.Item>
                          <p className="mi_dash_cont">No Data</p>
                        </List.Item>
                        <div style={{ boxShadow: "0 2px 10px 0 black" }}></div>
                      </>
                    )}
                  </List>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (role === "invitation manager") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_Brokers_invited}
                </p>
                <p className="mi_card_tit">Total Brokers Invited</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_agencies_invited}
                </p>
                <p className="mi_card_tit">Total Agencies Invited</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_Brokers_invited_current_month}
                </p>
                <p className="mi_card_tit">
                  Total Brokers Invited (Current Month)
                </p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_agencies_invited_current_month}
                </p>
                <p className="mi_card_tit">
                  Total Agencies Invited (Current Month)
                </p>
              </div>
            </Col>
          </Row>
          <Row span={24}>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_brokers_registered}
                </p>
                <p className="mi_card_tit">Total Brokers Registered</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_agencies_registered}
                </p>
                <p className="mi_card_tit">Total Agencies Registered</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_brokers_registered_current_month}
                </p>
                <p className="mi_card_tit">
                  Total Brokers Registered (Current Month)
                </p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {invitationManager.total_agencies_registered_current_month}
                </p>
                <p className="mi_card_tit">
                  Total Agencies Registered (Current Month)
                </p>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (role === "sales/finance team") {
      dashboard = (
        <div className="mi_main_div">
          <Row span={24}>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {salesFinance.total_commission_earned}
                </p>
                <p className="mi_card_tit">Total Commission</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {salesFinance.total_commission_earned_current_month}
                </p>
                <p className="mi_card_tit">Total Commission (Current Month)</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {salesFinance.total_adjustment_done}
                </p>
                <p className="mi_card_tit">Total Adjustment Done</p>
              </div>
            </Col>
            <Col lg={6} md={12} sm={24}>
              <div className="mi_card">
                <p className="mi_card_num">
                  {salesFinance.total_adjustment_done_current_month}
                </p>
                <p className="mi_card_tit">
                  Total Adjustment Done (Current Month)
                </p>
              </div>
            </Col>
          </Row>
          <Row span={24}>{searchfilter}</Row>
          <Row span={24}>
            <Col lg={12} md={24}>
              <div className="mi_card_chart">
                <p className="mi_das_tit">Carrier Vs Commission Trend</p>
                <Row span={24}>
                  <Col sm={24}>
                    {salesFinance.client_vs_com &&
                    salesFinance.client_vs_com.length > 0 ? (
                      <Chart
                        height="300px"
                        options={{
                          plotOptions: {
                            pie: {
                              donut: {
                                size: "85%",
                                labels: {
                                  show: true,
                                  name: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  value: {
                                    show: true,
                                    formatter: function (val) {
                                      return val;
                                    },
                                  },
                                  total: {
                                    show: true,
                                    showAlways: true,
                                    label: "Total Commission",
                                    formatter: function (w) {
                                      return (
                                        "$" +
                                        w.globals.seriesTotals.reduce(
                                          (a, b) => {
                                            return a + b;
                                          },
                                          0
                                        )
                                      );
                                    },
                                  },
                                },
                              },
                            },
                          },
                          labels: salesFinance.client_vs_com
                            ? salesFinance.client_vs_com.map((x) => x.label)
                            : [],
                          colors: [
                            "#F3B415",
                            "#F27036",
                            "#663F59",
                            "#6A6E94",
                            "#4E88B4",
                            "#00A7C6",
                            "#18D8D8",
                            "#A9D794",
                            "#46AF78",
                            "#A93F55",
                            "#8C5E58",
                            "#2176FF",
                            "#33A1FD",
                            "#7A918D",
                            "#BAFF29",
                          ],
                          dataLabels: {
                            enabled: false,
                          },
                          legend: {
                            show: false,
                          },
                        }}
                        series={
                          salesFinance.client_vs_com
                            ? salesFinance.client_vs_com.map((x) => x.val)
                            : []
                        }
                        type="donut"
                      />
                    ) : (
                      <Empty style={{ height: "277px" }}></Empty>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else if (role === "report ccheduler") {
      dashboard = <div className="mi_main_div"></div>;
    } else {
      dashboard = <div className="mi_main_div"></div>;
    }
    return (
      <Content>
        <div className="mi_main_div" style={{ paddingTop: "1px" }}>
          <div
            style={{
              textAlign: "center",
              alignContent: "center",
              marginTop: "3%",
            }}
          >
            {
              userdId === "10304" && <></>
              // <iframe
              //   title="Report Section"
              //   width="100% auto"
              //   height="612"
              //   src="https://app.powerbi.com/view?r=eyJrIjoiZGU3NzQzY2MtODVhNi00ODE3LWFmNTQtMTg4MDFmOTQzOTQ5IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
              //   frameborder="0"
              //   allowFullScreen="true">
              // </iframe>
            }
            {userdId === "10307" && (
              // <iframe
              //   title="Report Section"
              //   width="100% auto"
              //   height="612"
              //   src="https://app.powerbi.com/view?r=eyJrIjoiOWUwM2FhZTUtNDMxZC00ZDJlLWFkMzQtMjVmMzAyM2QxZmJlIiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
              //   frameborder="0"
              //   allowFullScreen="true">

              // </iframe>
              <></>
            )}
            {userdId === "10297" && (
              <iframe
                title="Broker_V1(New)"
                width="1024"
                height="612"
                src="
             https://app.powerbi.com/view?r=eyJrIjoiMDg1NzVkMjItNzdkYS00N2M0LTk3OGMtMWVkYmE1Y2I1MWJkIiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            )}
            {userdId === "10302" && (
              <iframe
                title="Carrier_V1(New)"
                width="1024"
                height="612"
                src="
             https://app.powerbi.com/view?r=eyJrIjoiMDFjYjdlN2ItZDIzZi00NDQzLTkwODUtZTQxZGRlMDgwMDAwIiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            )}
            <div>
              {role === "member" && (
                <div>
                  <h2>Welcome to MiComp!...</h2>
                  <div>
                    <img
                      alt="example"
                      style={{
                        margin: "100px auto",
                        width: "300px",
                        marginTop: "100px",
                      }}
                      src={img1}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* </div> */}
          {/* {dashboard} */}
        </div>
      </Content>
    );
  }
}
export default Dashboard;
